import {executeWithIntercept, onRedirect, pageData, RouteData} from "@/helpers/CypressHelper";

describe('Desktop - Authenticated admin user categories tests', () => {
    beforeEach(() => {
        cy.useSharedAdminUserSession();

        onRedirect(() =>
            pageData().rent.visitWithIntercept()
        );
    });

    it('Should display empty category in breadcrumbs', () => {

        executeWithIntercept(() => cy.get('a').contains('EmptyCategory').click(),
            [pageData().rent.routes.categoriesData as RouteData]);

        cy.assertBreadCrumbLength(3);
    });

});